// extracted by mini-css-extract-plugin
export default {"account":"P0VFnw"};